import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { PageHeader } from 'components/header';

import DataDiriDetail from './Detail';
import DataDiriForm from './Form';

class DataDiri extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isUpdate: false
        }
    }

    render() {
        const { action } = this.props
        return (
            <>
                <PageHeader
                    className="site-page-header"
                    extra={[
                        action.update && !this.state.isUpdate ? <Button shape='circle' onClick={() => {
                            this.setState({
                                isUpdate: true
                            })
                        }}><EditOutlined /></Button> : null
                    ]}
                />

                {
                    this.state.isUpdate ? <DataDiriForm dataID={this.props.privilege.profile_ex.siswa_id} onCancel={() => {
                        this.setState({
                            isUpdate: false
                        })
                        this.props.onRefresh()
                    }} {...this.props}/> : <DataDiriDetail dataID={this.props.privilege.profile_ex.siswa_id} {...this.props}/>
                }
            </>
        )
    }
}


export default DataDiri;